import React from 'react';
import theme from "styled-theming";
import styled from "styled-components";

import { ThemeType } from "shared/styles/theme";
import colors from "shared/styles/colors";
import { getFrendsLogoSvg } from "shared/icons/svgHelpers";

interface FrendsLogoItemProps {
    href: string
}

const FrendsLogoSvgPathFill = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.white,
});

const StyleFrendsLogoLink = styled.a`
    svg path {
        fill: ${FrendsLogoSvgPathFill};
    }
`

export const FrendsLogoItem: React.FC<FrendsLogoItemProps> = ({ href }) => {
    return (
        <li>
            <StyleFrendsLogoLink
                className="frends-logo"
                href={href}
                dangerouslySetInnerHTML={{__html: getFrendsLogoSvg()}}
            />
        </li>
    )
}
